<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    width="900px"
    :destroyOnClose="true"
  >
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      layout="inline"
      :label-col="{ style: { width: '80px' } }"
      :wrapper-col="{ style: { width: '330px' } }"
    >
      <template v-if="modalConfig.type === 'aboutInfo'">
        <a-form-item label="相关类型" name="type">
          <a-select
            v-model:value="formState.product"
            :options="aboutProductOptions"
            placeholder="请选择相关类型"
            allowClear
          >
          </a-select>
        </a-form-item>

        <a-form-item label="标题" name="name">
          <a-input v-model:value="formState.model" placeholder="请输入相关信息标题" allowClear>
          </a-input>
        </a-form-item>

        <a-form-item label="停用" name="isDeactivate">
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model:checked="formState.isDeactivate"
          />
        </a-form-item>

        <a-form-item label="内容" name="content" :wrapper-col="{ style: { width: '760px' } }">
          <wang-editor
            ref="wangEditorRef"
            style="width: 760px"
            @uploadlFile="uploadlFile"
          ></wang-editor>
        </a-form-item>
      </template>

      <template v-else>
        <a-form-item label="目录" name="catalog">
          <a-select
            v-model:value="formState.catalog"
            :options="catalogOptions"
            placeholder="请选择目录"
            allowClear
          >
          </a-select>
        </a-form-item>

        <a-form-item label="产品" name="product">
          <a-select
            v-model:value="formState.product"
            :options="options.machineOptions"
            @change="() => (formState.model = null)"
            placeholder="请选择产品"
            allowClear
          >
          </a-select>
        </a-form-item>

        <a-form-item label="型号" name="model">
          <a-select
            v-model:value="formState.model"
            :options="optionsByProduct"
            placeholder="请选择型号"
            allowClear
          >
          </a-select>
        </a-form-item>

        <a-form-item label="停用" name="isDeactivate">
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model:checked="formState.isDeactivate"
          />
        </a-form-item>

        <a-form-item label="产品手册" name="colorPageFile">
          <upload
            accept="file"
            :value="formState.colorPageFile"
            :uploadFn="uploadColorPageFile"
            uploadFimeName="files"
            ref="uploadImg"
          ></upload>
        </a-form-item>

        <!-- <a-form-item label="封面" name="picture">
                <upload-img :attachment="JSON.stringify(formState.picture?.split(','))" :requestFn="uploadProductInfo" :maxCount="1"
                    ref="uploadImg"></upload-img>
            </a-form-item> -->

        <!-- <a-form-item label="" name="">

            </a-form-item> -->

        <a-form-item label="内容" name="content" :wrapper-col="{ style: { width: '760px' } }">
          <wang-editor
            ref="wangEditorRef"
            style="width: 760px"
            @uploadlFile="uploadlFile"
          ></wang-editor>
        </a-form-item>
      </template>
    </a-form>
  </a-modal>
</template>

<script>
import { computed, defineComponent, reactive, ref, nextTick } from "vue";
import { Toast, timeStampToTime, uploadMedia } from "@/utils";
import options from "@/components/cascader/option.js";
import { catalogOptions, aboutProductOptions } from "./data";
import {
  saveProductInfo,
  uploadProductInfo,
  deleteProductInfoAnnex,
  uploadColorPageFile,
} from "@/request/view/productPublicityDept.js";
import wangEditor from "./editor.vue";
import upload from "@/components/upload/index.vue";

export default defineComponent({
  components: {
    wangEditor,
    upload,
  },
  setup(props, context) {
    const formRef = ref();

    const wangEditorRef = ref();

    const uploadImg = ref();

    const cacheURL = [];

    const formState = reactive({
      catalog: null,
      content: "",
      id: null,
      isDeactivate: null,
      model: null,
      picture: null,
      colorPageFile: "",
      product: null,
      pv: 0,
      sharingFrequency: 0,
      updateTime: null,
      video: null,
    });

    const optionsByProduct = computed(() => {
      if (!formState.product) return [];
      return options.machineOptions.filter((f) => f.value === formState.product)[0].children;
    });

    const rules = {
      catalog: [{ required: true, message: "请选择目录", trigger: "change" }],
      product: [{ required: true, message: "请选择产品", trigger: "change" }],
      // model: [{ required: true, message: '请选择型号', trigger: 'change' }],
      aboutInfo: [{ required: true, message: "请选择相关类型", trigger: "change" }],
    };
    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const filterAnnpex = (str) => str.split('"').filter((f) => f.indexOf("http") !== -1);

    const setUploadFileList = () => {
      const list = filterAnnpex(formState.content);
      if (list.length == 0) return;
      cacheURL.push(...list);
    };

    const deleteDiffrentFilePath = () => {
      const currentFile = filterAnnpex(formState.content);
      currentFile.forEach((path) => {
        const fileIndex = cacheURL.findIndex((f, index) => f === path);
        if (fileIndex !== -1) cacheURL.splice(fileIndex, 1);
      });

      if (cacheURL.length > 0) deleteProductInfoAnnex(cacheURL);
    };

    const showModal = (type, options) => {
      const { title, data } = options;
      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
        setUploadFileList();
      }
      modalConfig.title = title;
      modalConfig.visible = true;
      modalConfig.type = type;
      nextTick(() => {
        wangEditorRef.value.setValue(formState.content ? formState.content : "");
      });

      if (modalConfig.type === "aboutInfo") formState.catalog = "相关信息";

      if (formState.catalog === "相关信息") modalConfig.type = "aboutInfo";
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.visible = false;
      modalConfig.type = null;
      formState.pv = 0;
      formState.colorPageFile = "";
      formState.sharingFrequency = 0;
      formState.content = "";
      cacheURL.length = 0;
    };

    const uploadlFile = (path) => {
      cacheURL.push(path);
    };

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleOk = async () => {
      formState.content = wangEditorRef.value.valueHtml;
      let colorPageFile = [];
      if (uploadImg.value && uploadImg.value.getFile) {
        const fileList = uploadImg.value.getFile(true);

        fileList.forEach((file) => {
          colorPageFile.push(file.url);
        });
      }

      formState.colorPageFile = colorPageFile.join(",");
      formRef.value
        .validateFields()
        .then((res) => {
          formState.updateTime = timeStampToTime("", "seconds");
          saveProductInfo(formState).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            if (res.code !== 200) return;
            deleteDiffrentFilePath();
            handleCancel();
            context.emit("handleUpdateTable");
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    return {
      formState,
      wangEditorRef,
      rules,
      options,
      catalogOptions,
      optionsByProduct,
      uploadProductInfo,
      uploadColorPageFile,
      uploadImg,
      showModal,
      uploadlFile,
      formRef,
      handleCancel,
      handleOk,
      aboutProductOptions,
      modalConfig,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 10px;
}
</style>
